// src/components/Dashboard.js
import React, { useMemo } from 'react';
import { useData } from '../contexts/DataContext';
import {
  Grid,
  Typography,
  Box,
  Paper,
} from '@mui/material';
import Speedometer from './Speedometer';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

export default function Dashboard() {
  const { stats, latest, trackpoints } = useData();
  console.log(trackpoints);
  // 🕒 Past 10 min of points for the graph
  const graphData = useMemo(() => {
    const now = Date.now();
    return trackpoints
      .filter((p) => p.timestampMs && now - p.timestampMs <= 10 * 60 * 1000)
      .map((p) => ({
        time: new Date(p.timestampMs).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
        speed: parseFloat(p.speedKmh?.toFixed(1)) || 0,
      }));
  }, [trackpoints]);

  const fields = [
    {
      label: 'Snelheid',
      value: latest?.speedKmh != null ? `${latest.speed.toFixed(1)} km/h` : '–',
    },
    {
      label: 'gemiddelde (10 min)',
      value: stats?.avgSpeed10 != null ? `${stats.avgSpeed10.toFixed(1)} km/h` : '–',
    },
    {
      label: 'Batterij',
      value: latest?.batt != null ? `${latest.batt*100}%` : '–',
    },
  ];

  if (!stats && !latest) return null;

  return (
    <Box sx={{ px: 2, py: 3 }}>
      {/* Speedometer */}
      <Speedometer />

      {/* Stats Grid */}
      <Grid container spacing={3} justifyContent="center" sx={{ mb: 3 }}>
        {fields.map(({ label, value }) => (
          <Grid item xs={4} key={label}>
            <Box textAlign="center">
              <Typography variant="body2" color="text.secondary">
                {label}
              </Typography>
              <Typography variant="h6" fontWeight="bold">
                {value}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* 📈 Speed Graph */}
      <Box sx={{ width: '100%', height: 200 }}>
        <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
          <Typography variant="subtitle1" gutterBottom>
            Snelheid (laatste 10 min)
          </Typography>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={graphData}>
              <XAxis dataKey="time" tick={{ fontSize: 10 }} />
              <YAxis domain={[0, 50]} tick={{ fontSize: 10 }} unit=" km/h" />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="speed"
                stroke="#1976d2"
                strokeWidth={2}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </Paper>
      </Box>
    </Box>
  );
}
